import { useCallback } from 'react';

import { useRequestMagicLinkMutation } from '@ocx/graphql';
import { useConfiguration } from '@ocx/data-configuration';

import { RequestMagicLinkParams } from './signup.types';

export const useRequestMagicLink = () => {
  const {
    config: { brandUuid, chainId },
  } = useConfiguration();

  const [_requestMagicLink, { loading }] = useRequestMagicLinkMutation({ fetchPolicy: 'network-only' });

  const requestMagicLink = useCallback(
    async (values: RequestMagicLinkParams): Promise<{ success: boolean }> => {
      const res = await _requestMagicLink({
        variables: {
          input: {
            identifier: values.phoneNumber,
            brandUuid,
            chainId,
            referralCode: values.referralCode || undefined,
          },
        },
      });

      if (res.errors?.length) {
        throw res.errors[0];
      }

      return { success: res?.data?.requestMagicLink ?? false };
    },
    [_requestMagicLink, brandUuid, chainId],
  );

  return { requestMagicLink, isLoading: loading };
};
